import React from 'react';
import { EcoClub5Class2026 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub5Class2026/>;
};

export default AccountGeneralPage;